import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Estrutura Organizacional',
    path: '/gestao/estruturaorganizacional',
    name: 'estruturaorganizacional',
    component: () => import('@/views/gestao/estruturaorganizacional/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTRUTURAORGANIZACIONALNOVO_MENU_1400700199],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Estrutura Organizacional',
    path: '/gestao/estruturaorganizacional/cadastro/:id?',
    parent: 'estruturaorganizacional',
    name: 'estruturaorganizacional_create',
    component: () => import('@/views/gestao/estruturaorganizacional/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTRUTURAORGANIZACIONALNOVO_MENU_1400700199],
    },
    goesToMenu: true,
  },
];
